<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file MainNavigationSideNav.vue is part of event_pass_client.dev.     -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - MainNavigationSideNav.vue can not be copied and/or distributed            -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<!--//Created by keni.--><!--//User: keni--><!--//Date: 06/03/2018--><!--//Time: 20:10-->
<!--:class="{-->
<!--'sidenavIn':side_nav.active === true,-->
<!--'sidenavOut':side_nav.active !== true-->

<!--}"-->
<template>
    <div>
        <transition name="sidenav" v-on:after-enter="initCollapsibleLinks()">
            <div v-if="side_nav.active === true"
                    id="main-nav--side-nav"
                    class="side-nav"
            >
                <!--header main links-->
                <div class="m-1 d-flex justify-content-between align-items-center">
                    <div class="side-nav--user-links cursor-pointer"
                            v-on:click="triggerSideNavActive"
                    >
                        <i class="material-icons md-36" aria-hidden="true">menu</i>
                    </div>

                    <!--goto account-->
                    <div
                            v-on:click="linkTo(the_routes.account.url)"
                            :title="the_routes.account.title"
                            class="side-nav--user-links cursor-pointer"

                    >
                        <i class="material-icons md-36 "
                                :class="{
                                    'text-disabled':!(user_auth)
                                }"
                                aria-hidden="true"
                        >
                            <template v-if="user_auth">
                                account_circle
                            </template>
                            <template v-else>
                                perm_identity
                            </template>
                        </i>
                    </div>
                    <!--login user-->

                    <div v-on:click="linkTo(the_routes.home.url)"
                            :title="the_routes.home.title"
                            class="side-nav--user-links cursor-pointer"
                    >
                        <i class="material-icons md-36" aria-hidden="true">home</i>
                    </div>
                </div>


                <ul class="custom-scrollbar">
                    <!--logo wrapper-->
                    <li data-logo>
                        <div class="logo-wrapper waves-light">
                            <a href="#"
                                    class="d-flex justify-content-center"
                                    data-home="route('public.home')"
                            >
                                <img :src="readLogo()"
                                        class="img-fluid"
                                ></a>
                        </div>
                    </li>
                    <!--search and greetings-->
                    <li data-greeting class="p-2 border-bottom">
                        <div class="d-flex justify-content-between">
                            <!--user name-->
                            <div v-if="!searchActiveState"
                                    :class="{
                                    'search-state-active':searchActiveState
                                    }"
                                    class="p-2 text-center text-uppercase"
                            >
                                <div v-if="the_user_auth">
                                    Hi {{the_user_auth.first_name}}!
                                </div>
                                <div v-else>
                                    Hey there
                                </div>
                            </div>
                            <!--search block-->
                            <global_search data-global-search
                                    class="ml-2 mr-3 my-2 p-2"
                                    :class="{'w-100':searchActiveState}"
                                    :content="the_search"
                                    :no_placeholder="true"
                                    @searchActive="searchActive"
                            ></global_search>
                        </div>
                    </li>
                    <!--social-links-->
                    <!--<li data-social-links v-if="show_social_links">-->
                    <!--<ul class="social">-->
                    <!--<li><a href="#"-->
                    <!--class="icons-sm fb-ic"-->
                    <!--&gt;<i class="fa fa-facebook"> </i></a></li>-->
                    <!--<li><a href="#"-->
                    <!--class="icons-sm pin-ic"-->
                    <!--&gt;<i class="fa fa-pinterest"> </i></a></li>-->
                    <!--<li><a href="#"-->
                    <!--class="icons-sm gplus-ic"-->
                    <!--&gt;<i class="fa fa-google-plus"> </i></a></li>-->
                    <!--<li><a href="#"-->
                    <!--class="icons-sm tw-ic"-->
                    <!--&gt;<i class="fa fa-twitter"> </i></a></li>-->
                    <!--</ul>-->
                    <!--</li>&lt;!&ndash;/Social&ndash;&gt;&lt;!&ndash;Search Form&ndash;&gt;-->
                    <!--pages-custom-->
                    <li data-pages-custom>
                        <ul class="collapsible collapsible-accordion">
                            <li data-test-li v-for="page in pages.main"

                            >
                                <!--{{log('page',page)}}-->
                                <main-navigation-side-nav-list-item
                                        :page_route="page.route"
                                        :title="page.title"
                                        :name="page.name"
                                        :icon="(page.hasOwnProperty('icon'))?page.icon:null"
                                />
                            </li>
                        </ul>
                    </li>
                    <!--pages-fixed-->
                    <li data-fixed-links v-if="show_fixed_pages">
                        <ul class="collapsible collapsible-accordion">
                            <li v-for="fixedPage in fixedPages">
                                <a class="collapsible-header waves-effect arrow-r"><i class="fa fa-chevron-right"></i>
                                    {{fixedPage.title}}
                                    <i class="fa fa-angle-down rotate-icon"></i>
                                </a>
                                <div v-if="fixedPage.hasOwnProperty('pages')" class="collapsible-body">
                                    <ul>
                                        <li v-for="fixedPagePage in fixedPage.pages">
                                            <a href="#"
                                                    class="waves-effect"
                                            >Submit listing</a>
                                        </li>
                                        <li><a href="#"
                                                class="waves-effect"
                                        >Registration form</a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <a class="collapsible-header waves-effect arrow-r"><i class="fa fa-chevron-right"></i>
                                    Submit blog
                                    <i class="fa fa-angle-down rotate-icon"></i>
                                </a>
                                <div class="collapsible-body">
                                    <ul>
                                        <li><a href="#"
                                                class="waves-effect"
                                        >Submit listing</a></li>
                                        <li><a href="#"
                                                class="waves-effect"
                                        >Registration form</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <a class="collapsible-header waves-effect arrow-r"><i class="fa fa-hand-pointer-o"></i>Instruction<i class="fa fa-angle-down rotate-icon"></i></a>
                                <div class="collapsible-body">
                                    <ul>
                                        <li><a href="#"
                                                class="waves-effect"
                                        >For bloggers</a></li>
                                        <li><a href="#"
                                                class="waves-effect"
                                        >For authors</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <a class="collapsible-header waves-effect arrow-r"><i class="fa fa-eye"></i> About<i class="fa fa-angle-down rotate-icon"></i></a>
                                <div class="collapsible-body">
                                    <ul>
                                        <li><a href="#"
                                                class="waves-effect"
                                        >Introduction</a></li>
                                        <li><a href="#"
                                                class="waves-effect"
                                        >Monthly meetings</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <a class="collapsible-header waves-effect arrow-r"><i class="fa fa-envelope-o"></i> Contact me<i class="fa fa-angle-down rotate-icon"></i></a>
                                <div class="collapsible-body">
                                    <ul>
                                        <li><a href="#"
                                                class="waves-effect"
                                        >FAQ</a></li>
                                        <li><a href="#"
                                                class="waves-effect"
                                        >Write a message</a></li>
                                        <li><a href="#"
                                                class="waves-effect"
                                        >FAQ</a></li>
                                        <li><a href="#"
                                                class="waves-effect"
                                        >Write a message</a></li>
                                        <li><a href="#"
                                                class="waves-effect"
                                        >FAQ</a></li>
                                        <li><a href="#"
                                                class="waves-effect"
                                        >Write a message</a></li>
                                        <li><a href="#"
                                                class="waves-effect"
                                        >FAQ</a></li>
                                        <li><a href="#"
                                                class="waves-effect"
                                        >Write a message</a></li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <ul class="collapsible collapsible-accordion">
                            <li>
                                <a class="collapsible-header waves-effect"
                                        :title="the_routes.login.title"
                                        v-on:click="linkTo(the_routes.login.url)"
                                >
                                    <div class="d-flex justify-content-start align-items-center ">
                                        <i class="material-icons fs-4" aria-hidden="true">
                                            <template v-if="the_user_auth">
                                                exit_to_app
                                            </template>
                                            <template v-else>
                                                perm_identity
                                            </template>
                                        </i>

                                        <template v-if="the_user_auth">
                                            Log out
                                        </template>
                                        <template v-else>
                                            Log in
                                        </template>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </transition>


        <!--overlay-->
        <transition name="fade">
            <div v-if="side_nav.active"
                    v-on:click="triggerSideNavActive"
                    id="sidenav-overlay"
            >
            </div>
        </transition>
    </div>

</template>

<script>
	Vue.component('main-navigation-side-nav-list-item', require('./MainNavigationSideNavListItem'));
	Vue.component('main-navigation-search-top', require('./MainNavigationSearchTop'));
	export default {
		name: "main-navigation-side-nav",
		components: {},
		props: ['user_auth', 'routes', 'search'],
		created() {
			let _this = this;

			this.$eventHubMainNav.$on('side_nav', function (data) {
				_this.side_nav = data;
// console.log('side_nav',data)
			});
			this.$eventHubMainNav.$on('side_nav_pages', function (data) {
				_this.pages = data;
			});
		},
		destroyed() {
		},
		mounted() {
			// console.log('mounted', 'this.user_auth', this.user_auth);
		},
		data() {
			return {
				searchActiveState: false,
				show_fixed_pages: false,
				show_social_links: false,
				side_nav: {
					active: false
				},
				pages: Array,
				/**
				 * @property fixedPages.name
				 * @property fixedPages.title
				 * @property fixedPages.route
				 * @property fixedPages.icon
				 *
				 * {Array<Object>} fixedPages
				 */
				fixedPages: [
					{
						name: '',
						route: '',
						icon: '',
						title: '',
						pages: [
							{
								name: '',
								route: '',
								icon: '',
								title: '',
								pages: []
							}
						]
					}
				],
			}
		},
		watch: {},
		methods: {
			searchActive(stateActive) {
				// console.log('searchActive', 'stateActive', stateActive);
				this.searchActiveState = stateActive;
			},
			linkTo(route) {
				window.location.href = route;
			},
			initCollapsibleLinks() {
				$('.collapsible').collapsible();
			},
			readLogo() {
				return process.env.MIX_MY_LOGO;
			},
			triggerSideNavActive() {
				this.side_nav.actuve = false;

				//emit back to the main nav
				this.$eventHubMainNav.$emit('side_nav_close', this.side_nav.actuve);
			},
			log() {
				// 1. Convert args to a normal array
				let args = Array.prototype.slice.call(arguments);

				// 2. Prepend log prefix log string
				// args.unshift(LOG_PREFIX + " ");

				// 3. Pass along arguments to console.log
				console.log.apply(console, args);
				// console.log(arguments);
			}
		},
		computed: {
			the_search() {
				return JSON.parse(this.search);
			},
			the_routes() {
				return JSON.parse(this.routes);
			},
			the_user_auth() {
				return JSON.parse(this.user_auth);
			},
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/nav/MainNavigationSideNav.vue